export const docsBasePath = '/docs';

export function docsHref(path: `/${string}` | '') {
  if (path === '' || path === '/') return docsBasePath;
  return `${docsBasePath}${path}`;
}

export function docsRoute(path: `/${string}`) {
  return path;
}
